var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.items,"rules":_vm.responsibleRules,"label":_vm.label,"item-text":"fullName","item-value":"id","hide-no-data":"","return-object":"","filter":_vm.customFilter,"required":""},on:{"update:search-input":function (v) {
				_vm.listenSearch(v);
			},"change":function (v) {
				_vm.listenInput(v);
			}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }